"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __importDefault(require("lodash"));
var refdata_1 = require("@dayone/refdata");
var error = function (key, data) {
    var errorString = lodash_1.default.get(refdata_1.validationErrors, key, key);
    for (var _i = 0, _a = Object.keys(data); _i < _a.length; _i++) {
        var key_1 = _a[_i];
        //@ts-ignore
        errorString = errorString.replace(new RegExp("{{".concat(key_1, "}}"), 'g'), data[key_1]);
    }
    return errorString;
};
exports.default = error;
